import React, { Component } from "react";

class FormWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = { submitting: false };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFilesSelection = this.handleFilesSelection.bind(this);
    this.doSubmit = this.doSubmit.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleFilesSelection(e) {
    const target = e.target;
    const value = target.files[0];
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  doSubmit(e) {
    e.preventDefault();
    if (this.state.submitting) {
      return;
    }
    this.setState({ submitting: true });

    const form = e.target;
    const name = form.getAttribute("name");

    try {
      if (!form.checkValidity()) {
        return;
      }

      let formData = encode({
        "form-name": name,
        ...this.state,
        path: this.props.path ? this.props.path : "",
      });

      //console.debug(this.state);

      fetch("/en", {
        method: "POST",
        body: formData,
      })
        .then((data) => {
          if (data.status === 200 && data.ok) {
            this.doSuccess(name);
          } else {
            this.doError(name, data.status);
          }
        })
        .catch((error) => this.doError(name, error));
    } catch (ex) {
      this.doError(name, ex);
    }
  }

  doSuccess(name) {
    this.triggerGaEvent(true, name);

    if (this.props.onSuccess) {
      this.props.onSuccess();
      return;
    }
    this.setState({ submitting: false });
    this.setState({ formState: "success" });
  }

  doError(name, message) {
    this.triggerGaEvent(false, name);
    this.setState({ submitting: false });
    console.error(message);
    this.setState({ formState: "error" });
  }

  triggerGaEvent(success, formName) {
    if (window && window.ga && typeof window.ga === "function") {
      window.ga(
        "send",
        "event",
        "form",
        success ? "submit-success" : "submit-fail",
        formName
      );
    }
  }

  render() {
    const children = React.Children.map(this.props.children, (child) => {
      return React.cloneElement(child, {
        handleChange: this.handleInputChange,
        handleFilesSelection: this.handleFilesSelection,
        submitForm: this.doSubmit,
        formState: this.state.formState,
        path: this.props.path,
      });
    });
    return <>{children}</>;
  }
}

function encode(data) {
  const formData = new FormData();

  for (const key of Object.keys(data)) {
    formData.append(key, data[key]);
  }

  return formData;
}

export default FormWrapper;
